import script from "./CheckLabDefinitionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckLabDefinitionPanel.vue?vue&type=script&setup=true&lang=js"

import "./CheckLabDefinitionPanel.vue?vue&type=style&index=0&id=66dcd3f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dcd3f5"]])

export default __exports__